<template>
  <div class="sw-model-visualization__dimensions
      sw--position-absolute
      sw--position-relative--tab
      sw--width-full
      sw-grid-flex
      sw-grid-flex--justify-center
      sw-grid-flex--justify-flex-start--tab
      sw--margin-bottom-6--tab">
    <div class="sw-grid-flex sw-grid-flex--dir-column">
      <div class="sw-grid-flex__cell">
        <div class="sw-grid-flex sw-grid-flex--justify-center sw-grid-flex--align-center">
          <div class="sw-grid-flex">
            <div class="sw--border-transparent-1">
              <div class="sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2">
                <span class="sw-dms--text-light">X</span> <span
                class="sw--font-weight-bold">{{ x }}</span>
              </div>
            </div>
            <div class="sw--border-transparent-1">
              <div class="sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2">
                <span class="sw-dms--text-light">Y</span> <span
                class="sw--font-weight-bold">{{ y }}</span>
              </div>
            </div>
            <div class="sw--border-transparent-1">
              <div class="sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2">
                <span class="sw-dms--text-light">Z</span> <span
                class="sw--font-weight-bold">{{ z }}</span>
              </div>
            </div>
          </div>

          <div class="sw-dropdown--plain sw-dropdown__container sw--border-none">
            <select data-sw-dropdown data-sw-dropdown-vendor="selectric" name="scale"
              class="sw-dropdown__select">
              <template v-for="(label, value) in getScalesForSelect()">
                <option :selected="value === scale" :value="value">{{ label }}</option>
              </template>
            </select>
          </div>
        </div>
      </div>
      <table class="sw--more-dims
          sw-dms--color-grey-46
          sw--width-full
          sw--margin-top-3
          sw--margin-top-0--tab
          sw--display-table--tab">
        <tbody>
        <tr>
          <td class="sw--vertical-align__bottom sw--display-table-cell">Part Volume</td>
          <td class="sw--text-right sw--vertical-align__bottom sw--display-table-cell">
            {{ modelVolume }} {{ unit }}<sup>3</sup>
          </td>
        </tr>
        <tr>
          <td class="sw--vertical-align__bottom sw--display-table-cell">Machine Space</td>
          <td class="sw--text-right sw--vertical-align__bottom sw--display-table-cell">
            {{ machineSpace }} {{ unit }}<sup>3</sup>
          </td>
        </tr>
        <tr>
          <td class="sw--vertical-align__bottom sw--display-table-cell">Support Structure</td>
          <td class="sw--text-right sw--vertical-align__bottom sw--display-table-cell">
            {{ supportStructure }} {{ unit }}<sup>3</sup>
          </td>
        </tr>
        <tr>
          <td class="sw--vertical-align__bottom sw--display-table-cell">Parts Bounds Volume</td>
          <td class="sw--text-right sw--vertical-align__bottom sw--display-table-cell">
            <!--TODO: look at todo below-->
            {{ partsBoundsVolume }} cm<sup>3</sup>
          </td>
        </tr>
        <tr>
          <td class="sw--vertical-align__bottom sw--display-table-cell sw--padding-top-1">Part Count</td>
          <td class="sw--text-right sw--vertical-align__bottom sw--display-table-cell sw--padding-top-1">
            {{ partCount }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
  import VueExternalModuleMixin from 'js/lib/vue/mixins/vue-external-module-mixin';
  import swDropdown from 'js/sw-jquery/view-builders/sw-dropdown';

  export const ModelFixDimensionsScales = Object.freeze({
    MM: {value: 'mm', name: 'Mm', select: 'MM'},
    IN: {value: 'in', name: 'Inch', select: 'IN', unit: 'inch'},
    CM: {value: 'cm', name: 'Cm', unit: 'cm'}
  });

  export default {
    name: 'model-fix-dimensions',

    mixins: [VueJQueryMixin, VueExternalModuleMixin],

    props: {
      modelDimensions: {
        type: Object
      },
      pricingDimensions: {
        type: Object
      }
    },

    data: () => ({
      emptyValue: '--',
      scale: ModelFixDimensionsScales.MM.value
    }),

    mounted() {
      const _this = this;
      const $dropdownEl = _this.$jQuery('[data-sw-dropdown]', _this.$jQuery(_this.$el));

      _this.loadExternalModule(function () {
        swDropdown($dropdownEl);
      });

      $dropdownEl.on('change', function (e) {
        _this.scale = e.target.value;
      });
    },

    computed: {
      x() {
        if (this.modelDimensions) {
          return this.modelDimensions[`width${this.getScaleName()}`];
        }
        return null;
      },
      y() {
        if (this.modelDimensions) {
          return this.modelDimensions[`height${this.getScaleName()}`];
        }
        return null;
      },
      z() {
        if (this.modelDimensions) {
          return this.modelDimensions[`depth${this.getScaleName()}`];
        }
        return null;
      },
      modelVolume() {
        if (this.pricingDimensions) {
          return this.pricingDimensions[`materialVolume${this.getScaleName(true)}`];
        }
        return this.emptyValue || null;
      },
      machineSpace() {
        if (this.pricingDimensions) {
          return this.pricingDimensions[`machineVolume${this.getScaleName(true)}`];
        }
        return this.emptyValue || null;
      },
      supportStructure() {
        if (this.pricingDimensions) {
          return this.pricingDimensions[`supportVolume${this.getScaleName(true)}`];
        }
        return this.emptyValue || null;
      },
      partsBoundsVolume() {
        // TODO: missing other scale (inch, cm)!
        if (this.pricingDimensions) {
          return this.pricingDimensions['partsBoundsVolume'];
        }
        return this.emptyValue || null;
      },
      partCount() {
        if (this.pricingDimensions) {
          return this.pricingDimensions['partCount'];
        }
        return null;
      },
      unit() {
        if (this.scale === ModelFixDimensionsScales.MM.value) {
          return ModelFixDimensionsScales.CM.unit;
        } else {
          return ModelFixDimensionsScales[this.scale.toUpperCase()].unit;
        }
      }
    },

    methods: {
      getScaleName(isCm = false) {
        let scale = this.scale;
        if (isCm && scale === ModelFixDimensionsScales.MM.value) {
          scale = ModelFixDimensionsScales.CM.value;
        }
        return ModelFixDimensionsScales[scale.toUpperCase()].name;
      },
      getScalesForSelect() {
        const scales = {};
        Object.values(ModelFixDimensionsScales).forEach(scale => {
          if (scale.select) {
            scales[scale.value] = scale.select
          }
        });
        return scales;
      }
    }
  }
</script>
